"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionNotificationButton = exports.BUTTON_TYPE = exports.BUTTON_PRIORITY = exports.TEXT_BUTTON_PRIORITY = void 0;
var React = require("react");
var Button_1 = require("../../Button");
Object.defineProperty(exports, "BUTTON_PRIORITY", { enumerable: true, get: function () { return Button_1.PRIORITY; } });
var TextButton_1 = require("../../TextButton");
Object.defineProperty(exports, "TEXT_BUTTON_PRIORITY", { enumerable: true, get: function () { return TextButton_1.TEXT_BUTTON_PRIORITY; } });
var dataHooks_1 = require("../dataHooks");
var SectionNotification_st_css_1 = require("../SectionNotification.st.css");
var SectionNotificationButton_st_css_1 = require("./SectionNotificationButton.st.css");
var BUTTON_TYPE;
(function (BUTTON_TYPE) {
    BUTTON_TYPE["default"] = "default";
    BUTTON_TYPE["text"] = "text";
})(BUTTON_TYPE || (BUTTON_TYPE = {}));
exports.BUTTON_TYPE = BUTTON_TYPE;
var SectionNotificationButton = /** @class */ (function (_super) {
    __extends(SectionNotificationButton, _super);
    function SectionNotificationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textButtonDefaultProps = {
            priority: TextButton_1.TEXT_BUTTON_PRIORITY.primary,
        };
        _this.buttonDefaultProps = {
            priority: Button_1.PRIORITY.basic,
            size: Button_1.SIZE.tiny,
        };
        return _this;
    }
    SectionNotificationButton.prototype.render = function () {
        var _a = this.props, children = _a.children, type = _a.type, buttonProps = __rest(_a, ["children", "type"]);
        var ButtonComponent = (type === BUTTON_TYPE.text
            ? TextButton_1.TextButton
            : Button_1.Button);
        var defaultButtonProps = type === BUTTON_TYPE.text
            ? this.textButtonDefaultProps
            : this.buttonDefaultProps;
        return (React.createElement("div", { className: SectionNotificationButton_st_css_1.st(SectionNotificationButton_st_css_1.classes.root, { type: type }, SectionNotification_st_css_1.classes.button), "data-hook": dataHooks_1.SECTION_NOTIFICATION_DATA_HOOKS.button },
            React.createElement(ButtonComponent, __assign({ className: SectionNotificationButton_st_css_1.st(SectionNotificationButton_st_css_1.classes.button, {
                    priority: buttonProps.priority ||
                        defaultButtonProps.priority,
                }) }, defaultButtonProps, buttonProps), children)));
    };
    SectionNotificationButton.displayName = 'SectionNotification.Button';
    SectionNotificationButton.defaultProps = {
        type: BUTTON_TYPE.default,
    };
    return SectionNotificationButton;
}(React.Component));
exports.SectionNotificationButton = SectionNotificationButton;
//# sourceMappingURL=SectionNotificationButton.js.map